import Vue from 'vue'
import Form from '@/helpers/Form'

export default function (pluginsHandler) {
    return {
        name: 'editable',
        treeMixins: {
            props: {
                editableForm: {
                    type: Function,
                    required: true
                },
                editableFormEvents: {
                    type: Object
                },
                editablePreventFormSubmit: {
                    type: Boolean,
                    default: false
                },
                editableFormAttrs: {
                    type: Object
                }
            }
        },
        treeRowMixins: {
            mounted(){
                this.$refs.formNode.$on('submit', () => {
                    this.treeObject.$emit('editable:save', this.editableFormModel, this)
                })
            },
            data() {
                let self = this
                return {
                    editableToggleStatus: false,
                    editableFormModel: this.treeObject.editableForm(this.rowItem)
                }
            },
            methods: {
                editableToggle(itemData) {
                    this.editableShow = !this.editableShow //true if it is open, false if it is close
                    this.$emit('editable:toggle', itemData, this.editableShow)
                }
            },
            computed: {
                editableShow: {
                    get() {
                        return this.editableToggleStatus
                    },
                    set(val) {
                        this.editableToggleStatus = val
                    }
                },
                editableFormButtonsSlot() {
                    return pluginsHandler.getSlotContent('editable-slot-buttons') || false
                },
                editableFormFieldsSlot() {
                    return pluginsHandler.getSlotContent('editable-slot-fields') || false
                },
                editableFormListeners() {
                    let listeners = Object.assign({},
                        {
                            submit: (event) => {
                                if (!this.treeObject.editablePreventFormSubmit) {
                                    //default action here
                                    this.editableFormModel.validate().then((res) => {
                                        if (res.valid) {
                                            let tree = this.treeObject
                                            this.rowItem[tree.defaultPropertyTitleKey] = this.editableFormModel[tree.defaultPropertyTitleKey]
                                            this.editableToggle()
                                        }
                                    })
                                }
                            }
                        },
                        this.treeObject.editableFormEvents
                    )

                    return listeners
                }

            }
        },
        slotsContent: {
            'rowActions': `<span class="editable-controls oc-editable-action">
                            <span class="fa" :class="{'fa-edit': !editableShow, 'fa-times': editableShow, 'text-danger': editableShow}" @click="editableToggle(rowItem)"></span>
                           </span>
                            `,
            rowAppend: `<div class="editable-form oc-editable-form" v-show="editableShow">
                <oc-form
                    ref="formNode" :model="editableFormModel"
                    v-on="editableFormListeners"
                    v-bind="treeObject.editableFormAttrs"
                >
                    <template v-if="!editableFormFieldsSlot">
                        <oc-form-field
                            v-model="editableFormModel.name"
                            name="name"
                            input="text-input"
                        />
                    </template>
                    <template v-else>
                        ${pluginsHandler.getSlotContent('editable-slot-fields')}
                    </template>

                    <template v-if="!editableFormButtonsSlot">
                        <oc-button-input
                            class="btn btn-sm btn-success"
                            @click="$refs.formNode.$emit('submit')"
                            text="Save"
                        />
                    </template>
                    <template v-else>
                        ${pluginsHandler.getSlotContent('editable-slot-buttons')}
                    </template>
                </oc-form>
            </div>`
        },
    }
}
